import { render } from "./SignatureWrapper.vue?vue&type=template&id=1b7fc5a7&ts=true"
import script from "./SignatureWrapper.vue?vue&type=script&lang=ts"
export * from "./SignatureWrapper.vue?vue&type=script&lang=ts"

import exportComponent from "/home/ben/work/acon/acon-360/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__